import React from 'react';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import {
    compBgColor,
    compBorderRadius,
    compCommonPadd,
} from 'routes/adminMobile/constraints/AdminConst';

const AdminMobileContentBox = ({ children, flexStart }) => {
    return (
        <HorizontalFlex
            padding={compCommonPadd}
            backgroundColor={compBgColor}
            borderRadius={compBorderRadius}
            flexStart={flexStart}
        >
            <FlexChild >{children}</FlexChild>
        </HorizontalFlex>
    );
};

export default AdminMobileContentBox;
